import React from 'react';
import PropTypes from 'prop-types';
import { Button, Checkbox, TextInput } from '@opendate-app/setlist';

export const validPlaces = (places, max) => {
  const count = Number(places);
  return Number.isInteger(count) && count >= 1 && (max == null || count <= max);
};

const AreaPlacesList = ({ areas, onChangePlaces, onCommitPlaces, onToggleWhole, onRemove }) => (
  <div className="d-flex flex-column mt-3" style={{ gap: 12 }}>
    {areas.map(({ label, places, whole, max, busy }) => (
      <div key={label} className="d-flex flex-column" style={{ gap: 4 }}>
        <div className="d-flex align-items-end" style={{ gap: 8 }}>
          <div className="flex-fill">
            <TextInput
              label={`${label} places`}
              type="number"
              min={1}
              max={max ?? undefined}
              value={whole ? '' : String(places ?? '')}
              disabled={whole || busy}
              onChange={e => onChangePlaces(label, e.target.value)}
              onBlur={() => onCommitPlaces(label)}
              hint={!whole && max != null ? `Up to ${max} places` : undefined}
              error={!whole && !validPlaces(places, max) ? (max == null ? 'Enter at least 1 place' : `Enter 1 to ${max} places`) : undefined}
            />
          </div>
          <Button size="sm" variant="tertiary" disabled={busy} onClick={() => onRemove(label)}>Remove</Button>
        </div>
        <Checkbox label="Hold the whole area" checked={whole} disabled={busy} onChange={e => onToggleWhole(label, e.target.checked)} />
      </div>
    ))}
  </div>
);

AreaPlacesList.propTypes = {
  areas: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    places: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    whole: PropTypes.bool,
    max: PropTypes.number,
    busy: PropTypes.bool
  })).isRequired,
  onChangePlaces: PropTypes.func.isRequired,
  onCommitPlaces: PropTypes.func.isRequired,
  onToggleWhole: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired
};

export default AreaPlacesList;
